import { render, staticRenderFns } from "./NeoparentCreatePatient.vue?vue&type=template&id=76249558&scoped=true"
import script from "./NeoparentCreatePatient.vue?vue&type=script&lang=js"
export * from "./NeoparentCreatePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76249558",
  null
  
)

export default component.exports